import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SlidersHorizontal } from "lucide-react";
import { toast } from "sonner";
import { NeuButton, NeuCard, NeuInput } from "../../../components/neu/Neu";
import { saveAlertConfig } from "../../../api/platform";

const FIELDS = [
  ["error_rate", "system.rule_error_rate", "%"],
  ["disk", "system.rule_disk", "%"],
  ["memory", "system.rule_memory", "%"],
  ["capacity", "system.rule_capacity", "%"],
  ["voice_credits", "system.rule_voice_credits", "%"],
  ["cooldown_hours", "system.cooldown", "h"],
];

// Editable thresholds that drive the health alert cron.
export const AlertThresholdsCard = ({ data, onSaved }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (data) setForm(data);
  }, [data]);

  if (!form) return null;

  const save = async () => {
    setBusy(true);
    try {
      await saveAlertConfig(form);
      toast.success(t("system.thresholdsSaved"));
      onSaved?.();
    } finally {
      setBusy(false);
    }
  };

  return (
    <NeuCard data-testid="system-thresholds-card">
      <p className="label-xs flex items-center gap-2">
        <SlidersHorizontal className="h-4 w-4 text-primary" /> {t("system.thresholds")}
      </p>
      <p className="mt-1 text-xs text-muted-foreground">{t("system.thresholdsHint")}</p>

      <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
        {FIELDS.map(([key, label, unit]) => (
          <div key={key}>
            <p className="mb-1 text-[10px] font-bold text-muted-foreground">
              {t(label)} ({unit})
            </p>
            <NeuInput
              type="number"
              step="0.5"
              dir="ltr"
              data-testid={`threshold-${key}`}
              className="font-mono text-sm"
              value={form[key]}
              onChange={(e) => setForm({ ...form, [key]: Number(e.target.value) })}
            />
          </div>
        ))}
      </div>

      <NeuButton variant="primary" className="mt-4" data-testid="thresholds-save" disabled={busy} onClick={save}>
        {t("app.save")}
      </NeuButton>
    </NeuCard>
  );
};
